import React from "react";
import {
  LoginContainer,
  LoginImageSection,
  BrandLogo,
  ImageWrapper,
  LoginFormSection,
  LoginCard,
  MicrosoftButton,
  WelcomeText,
  SubText,
  StyledFooter,
} from "./Login.styled";
import Modal from "../../components/Modal/Modal";
import { useLoginService } from "./LoginService";
import InputField from "../../components/InputField/InputField";
import Checkbox from "../../components/Checkbox/Checkbox";
import Button from "../../components/Button/Button";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import InputAdornment from "@mui/material/InputAdornment";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const Login = () => {
  const { modal, handleMicrosoftLogin, handleKeycloakLogin, handleCloseModal } =
    useLoginService();
  const [rememberMe, setRememberMe] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    handleKeycloakLogin(email, password);
  };

  return (
    <LoginContainer>
      <LoginImageSection>
        <BrandLogo>FlashDice</BrandLogo>
        <ImageWrapper>
          <img
            src="/assets/login-illustration.svg"
            alt="Login illustration"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </ImageWrapper>
        <StyledFooter>
          <span>
            © {new Date().getFullYear()} FlashDice. All rights reserved.
          </span>
        </StyledFooter>
      </LoginImageSection>

      <LoginFormSection>
        {modal && (
          <Modal
            type={modal.type}
            title={modal.title}
            message={modal.message}
            onClose={handleCloseModal}
          />
        )}
        <LoginCard>
          <WelcomeText sx={{ mb: 0.5 }}>Welcome back</WelcomeText>
          <SubText sx={{ mb: 3 }}>Please enter your details</SubText>
          <Box
            component="form"
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
            onSubmit={handleSubmit}
          >
            <InputField
              label="Email"
              placeholder="Enter your email"
              type="email"
              autoComplete="username"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MailOutlineIcon color="action" fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
            <InputField
              label="Password"
              placeholder="Password"
              type="password"
              autoComplete="current-password"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlinedIcon color="action" fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mt: 0.5,
                mb: 1,
              }}
            >
              <Checkbox
                label="Remember me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                name="rememberMe"
              />
              <Link
                href="#"
                underline="hover"
                sx={{ fontSize: "0.87rem", fontWeight: 500 }}
              >
                Forgot password?
              </Link>
            </Box>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              size="small"
              type="submit"
            >
              Sign in
            </Button>
            <Link
              href="/signup"
              underline="hover"
              sx={{
                fontSize: "0.85rem",
                fontWeight: 500,
                display: "block",
                textAlign: "center",
                mt: 1,
              }}
            >
              Don't have an account? Sign up
            </Link>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              my: 2,
              gap: 2,
            }}
          >
            <Divider sx={{ flex: 1, opacity: 0.2 }} />
            <span
              style={{
                color: "#999",
                fontSize: "0.85rem",
                fontWeight: 500,
                whiteSpace: "nowrap",
              }}
            >
              Or continue with
            </span>
            <Divider sx={{ flex: 1, opacity: 0.2 }} />
          </Box>
          <MicrosoftButton
            type="button"
            onClick={handleMicrosoftLogin}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <img
              src="/assets/microsoft-logo.svg"
              alt="Microsoft"
              width="24"
              height="24"
              style={{ marginRight: "12px" }}
            />
            Sign in with Microsoft
          </MicrosoftButton>
        </LoginCard>
      </LoginFormSection>
    </LoginContainer>
  );
};

export default Login;
